import {getApp, getApps, initializeApp} from 'firebase/app';
import {Auth, getAuth} from 'firebase/auth';
import {environment} from '../environments/environment';

export const getFirebaseAuth = (): Auth => {
  const app = getApps().length > 0 ? getApp() : initializeApp(environment.firebaseConfig);
  return getAuth(app);
};

export const waitForFirebaseAuthState = (): Promise<void> => {
  return getFirebaseAuth().authStateReady();
};
